import { createI18n } from 'vue-i18n'

const messages = {
  zh: {
    nav: {
      home: '首页',
      search: '视频搜索',
      parser: '视频下载',
      director: 'AI编导',
      videoCreation: '视频创作',
      subtitleRemover: '去字幕',
      accountAnalysis: '账号分析',
      loginManagement: '登录管理',
      about: '关于'
    },
    menu: {
      dashboard: '仪表盘',
      inspiration: '灵感广场',
      videoGeneration: '视频生成',
      batchVideo: '批量视频生成',
      videoMatting: '视频高清化',
      promptGeneration: '提示词生成',
      imageGeneration: '图片生成',
      storyboard: '故事板',
      videoContinuation: '画面续写',
      characterManagement: '角色管理',
      videoReplication: '视频复刻',
      watermarkRemoval: '去水印/去字幕',
      taskQueue: '任务队列',
      personalCenter: '个人中心',
      personalInfo: '个人信息',
      rechargeCenter: '充值中心',
      affiliateProgram: '推广计划',
      about: '关于'
    },
    header: {
      contactSupport: '联系客服',
      balance: '余额',
      recharge: '充值'
    },
    dashboard: {
      welcome: '欢迎回来',
      consoleMsg: '这是您的创作控制台',
      overview: '数据概览',
      totalTasks: '总任务数',
      completed: '已完成',
      processing: '处理中',
      analysis: '数据分析',
      totalConsumption: '总消耗',
      todayConsumption: '今日消耗金额',
      dailyTrend: '每日消耗趋势'
    },
    home: {
      heroTitle: 'AI 驱动的视频创作革命',
      heroSubtitle1: '输入爆款视频链接，AI 自动重构脚本、生成分镜图，',
      heroSubtitle2: '一键创造属于你的原创视频内容',
      startCreation: '立即开始创作',
      learnMore: '了解更多',
      featuresTitle: '核心功能特性',
      featuresSub: '基于最新 AI 技术，为创作者提供全方位的视频创作解决方案',
      feature1Title: 'AI 智能分析',
      feature1Desc: '使用先进大模型深度解析视频内容，自动提取关键信息与创意逻辑',
      feature2Title: '一键生成',
      feature2Desc: '输入视频链接即可生成脚本、分镜图和拍摄指导，全流程自动化',
      feature3Title: '多样化风格',
      feature3Desc: '支持多种视频风格重构，轻松适配不同平台调性与受众喜好',
      feature4Title: '高效创作',
      feature4Desc: '大幅缩短视频制作周期，让创作更专注于创意本身',
      galleryTitle: '热门视频模板',
      gallerySub: '精选爆款视频结构，一键复用成功密码',
      useTemplate: '使用模板',
      likesDesc: '人点赞',
      shootingInstructions: '拍摄说明',
      badgeAdvance: '进阶拍',
      badgeSimple: '简单拍',
      badgeChallenge: '挑战拍'
    },
    parser: {
      title: '视频解析下载',
      subtitle: '支持 B站、抖音、小红书、YouTube、TikTok、快手、微博等20+平台视频无水印解析',
      parseBtn: '解析视频',
      recentParse: '最近解析',
      supportedPlatforms: '支持的平台 (20+)',
      estimated: '预估',
      noWatermark: '无水印',
      qualityBest: '最佳质量',
      qualityBestNoWatermark: '最佳质量(无水印)',
      qualityOriginal: '原始质量',
      qualityBestMute: '最佳质量(无声)',
      mute: '无声',
      lossless: '无损',
      standard: '标准',
      normal: '普通',
      badgeDouyin: '抖音',
      badgeXHS: '小红书',
      badgeKuaishou: '快手',
    }
  },
  en: {
    nav: {
      home: 'Home',
      search: 'Search',
      parser: 'Download',
      director: 'AI Director',
      videoCreation: 'Creation',
      subtitleRemover: 'Subtitles',
      accountAnalysis: 'Accounts',
      loginManagement: 'Login Manager',
      about: 'About'
    },
    menu: {
      dashboard: 'Dashboard',
      inspiration: 'Inspiration',
      videoGeneration: 'Video Gen',
      batchVideo: 'Batch Video Gen',
      videoMatting: 'Video HD',
      promptGeneration: 'Prompt Gen',
      imageGeneration: 'Image Gen',
      storyboard: 'Storyboard',
      videoContinuation: 'Video Continuation',
      characterManagement: 'Characters',
      videoReplication: 'Video Clone',
      watermarkRemoval: 'Remove Watermark',
      taskQueue: 'Task Queue',
      personalCenter: 'Personal Center',
      personalInfo: 'Profile',
      rechargeCenter: 'Recharge',
      affiliateProgram: 'Affiliates',
      about: 'About'
    },
    header: {
      contactSupport: 'Support',
      balance: 'Balance',
      recharge: 'Recharge'
    },
    dashboard: {
      welcome: 'Welcome back',
      consoleMsg: 'This is your creative console',
      overview: 'Data Overview',
      totalTasks: 'Total Tasks',
      completed: 'Completed',
      processing: 'Processing',
      analysis: 'Data Analysis',
      totalConsumption: 'Total Consumption',
      todayConsumption: 'Today\'s Consumption',
      dailyTrend: 'Daily Consumption Trend'
    },
    home: {
      heroTitle: 'AI-Driven Video Creation Revolution',
      heroSubtitle1: 'Input viral video links, AI reconstructs scripts & storyboards automatically,',
      heroSubtitle2: 'Create your original video content with one click',
      startCreation: 'Start Creating Now',
      learnMore: 'Learn More',
      featuresTitle: 'Core Features',
      featuresSub: 'Providing creators with comprehensive video creation solutions based on the latest AI tech',
      feature1Title: 'Smart AI Analysis',
      feature1Desc: 'Deeply analyze video content using advanced LLMs to auto-extract key info & logic',
      feature2Title: 'One-Click Generation',
      feature2Desc: 'Input link to generate scripts, storyboards & shooting guides automatically',
      feature3Title: 'Diverse Styles',
      feature3Desc: 'Support various video style reconstructions to easily adapt to different platforms',
      feature4Title: 'Efficient Creation',
      feature4Desc: 'Significantly reduce production cycles, letting you focus on creativity',
      galleryTitle: 'Hot Video Templates',
      gallerySub: 'Curated viral video structures to reuse success codes with one click',
      useTemplate: 'Use Template',
      likesDesc: ' likes',
      shootingInstructions: 'Shooting Guide',
      badgeAdvance: 'Advanced',
      badgeSimple: 'Easy',
      badgeChallenge: 'Challenge'
    },
    parser: {
      title: 'Video Parser & Download',
      subtitle: 'Supports 20+ platforms: Bilibili, Douyin, Xiaohongshu, YouTube, TikTok, Kuaishou, Weibo & more',
      parseBtn: 'Parse Video',
      recentParse: 'Recent Parses',
      supportedPlatforms: 'Supported Platforms (20+)',
      estimated: 'Est.',
      noWatermark: 'No Watermark',
      qualityBest: 'Best Quality',
      qualityBestNoWatermark: 'Best (No Watermark)',
      qualityOriginal: 'Original Quality',
      qualityBestMute: 'Best Quality (Mute)',
      mute: 'Mute',
      lossless: 'Lossless',
      standard: 'Standard',
      normal: 'Normal',
      badgeDouyin: 'Douyin',
      badgeXHS: 'Xiaohongshu',
      badgeKuaishou: 'Kuaishou',
    }
  }
}

const i18n = createI18n({
  legacy: false, // Set to false to use Composition API
  locale: 'zh', // Default language
  fallbackLocale: 'en',
  messages,
})

export default i18n
